import { makeAppStyles } from '@percept/mui'


export const usePerformanceTotalsTableStyles = makeAppStyles( theme => ({
  tableCell: {
    padding: theme.spacing(1),
    fontWeight: theme.typography.fontWeightBold,
  }
}))
